module.exports = __webpack_public_path__ + "img/image (14).a5e727e9.webp";